import { HomeOutlined } from '@mui/icons-material';
import {
    ListItemButton,
    ListItemIcon,
    ListItemText
} from '@mui/material';
import { COLOR_NAV_HOVER } from '../../theme';

type PropsType = {
    sx?: object,
    backgroundColor: string,
    textColor: string,
    active?: boolean,
    onClick: () => void
};

const HomeMenuItem: React.FC<PropsType> = (props) => {
    const {
        sx,
        backgroundColor,
        textColor,
        active = false,
        onClick
    } = props;

    return (
        <ListItemButton
            key="home"
            onClick={onClick}
            sx={{
                ...sx,
                background: backgroundColor,
                '&:hover': {
                    background: active ? backgroundColor : COLOR_NAV_HOVER
                }
            }}
        >
            <ListItemIcon sx={{ color: textColor }}>
                <HomeOutlined />
            </ListItemIcon>
            <ListItemText primary="Hem" sx={{ color: textColor }} />
        </ListItemButton>
    );
};

export default HomeMenuItem;
